import { getMyDefaultAddress } from '_api/address';

const entity = {
  state: {
    // 20201230 从选择地址页面，点中地址后，返回结算页，记录当前选中的地址信息
    currentChooseAd: {},
    // 用户的默认地址对象
    defaultAdObj: {},
    // 20210202 实物订单设置选中的tab
    entityOrderTab: ''
  },
  getters: {
    currentChooseAd: (state) => state.currentChooseAd,
    defaultAdObj: (state) => state.defaultAdObj,
    entityOrderTab: (state) => state.entityOrderTab
  },
  actions: {
    // 获取我的默认地址
    acGetDefaultAddress: ({ commit, state }, page = {}) => {
      try {
        return new Promise((resolve, reject) => {
          getMyDefaultAddress()
            .then((res) => {
              if (res && res.obj) {
                const defaultObj = res.obj || {};
                commit('SET_DEFAULT_ADDRESS', defaultObj);
              } else {
                commit('SET_DEFAULT_ADDRESS', {});
              }
              resolve(res.obj);
            })
            .catch((e) => {
              reject(e);
            });
        });
      } catch (e) {}
    }
  },
  mutations: {
    // 20201230 从选择地址页面，点中地址后，返回结算页，记录当前选中的地址信息
    SET_CURRENT_CHOOSE_AD(state, data) {
      state.currentChooseAd = data;
    },
    // 保存用户设置的默认地址
    SET_DEFAULT_ADDRESS(state, data) {
      state.defaultAdObj = data;
    },
    // 20210202 实物订单设置选中的tab
    SET_ENTITY_ORDER_TAB(state, data) {
      state.entityOrderTab = data;
    }
  }
};

export default entity;



// WEBPACK FOOTER //
// src/store/modules/entity.js